<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div>
        <br />
        <br />
        <br />
        <div class="iosSafe" />
        <ion-list lines="full" class="ion-no-margin">
          <ion-item>
            <ion-label> Terms and Conditions </ion-label>
          </ion-item>
          <ion-textarea
            readonly="true"
            rows="80"
            class="pre-formatted"
            v-model="tandcs"
          />
        </ion-list>
      </div>
      <ion-button @click="back()">Back</ion-button>
      <br />
      <br />
      <br />
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import router from "@/router";
import {
  IonContent,
  IonPage,
  IonList,
  IonLabel,
  IonItem,
  IonTextarea,
  IonButton,
} from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Tandcs",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonLabel,
    IonItem,
    IonTextarea,
    IonButton,
  },
  data() {
    return {
      tandcs: "",
    };
  },
  async mounted() {
    try {
      const text = await fetch("./assets/terms.txt");
      const realText = await text.text();
      this.tandcs = realText;
    } catch (e) {
      this.tandcs = "Error in text load " + e;
      console.log(this.tandcs);
    }
  },
  methods: {
    back() {
      router.back();
    },
  },
  computed: {},
});
</script>

<style scoped>
ion-menu-button {
  color: var(--ion-color-primary);
}

.iosSafe {
  height: env(safe-area-inset-top);
}

#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}

.pre-formatted {
  font-size: small;
  width: 100%;
  height: 100%;
  word-wrap: break-word;
  white-space: pre;
}
</style>